export interface PickableTag {
  id: string;
  name: string;
  color: string;
}

/** The tag as it appears on a generated slide's summary — read only. */
export function TagPill({ tag }: { tag: PickableTag }) {
  return (
    <span
      className="rounded-full px-2 py-0.5 text-[11px] font-semibold text-white"
      style={{ backgroundColor: tag.color }}
    >
      {tag.name}
    </span>
  );
}

export function TagToggle({
  tag,
  selected,
  onToggle,
}: {
  tag: PickableTag;
  selected: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      style={{ borderColor: tag.color, backgroundColor: selected ? tag.color : undefined }}
      className={`label flex h-8 items-center gap-2 whitespace-nowrap rounded-full border px-3 transition-colors ${
        selected
          ? "text-white shadow-sm"
          : "text-secondary-200 hover:bg-black/5 dark:hover:bg-white/5"
      }`}
    >
      {!selected && (
        <span className="h-2 w-2 rounded-full" style={{ backgroundColor: tag.color }} />
      )}
      {tag.name}
    </button>
  );
}
